import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { buildCreditPlanStoreKey, PlanLookup } from '../slices/creditPlanSlice';

export const selectCreditPlansDebugModeEnabled = (state: RootState) =>
  state.creditPlan.debugModeEnabled;
export const selectCreditPlansFetchStatus = (state: RootState) => state.creditPlan.fetchStatus;
export const selectCreditPlansGlobalContent = (state: RootState) => state.creditPlan.content;
export const selectCreditPlans = (state: RootState) => state.creditPlan.plans;
export const selectCreditPlan = createSelector(
  [
    (state: RootState) => state.creditPlan.plans,
    (_state: RootState, jurisdiction?: string) => jurisdiction
  ],
  (plans, jurisdiction) =>
    jurisdiction ? (plans.find(plan => plan.jurisdiction === jurisdiction) ?? null) : null
);

export const selectCreditPlanLoadingStepIndex = createSelector(
  [
    (state: RootState) => state.creditPlan.loadingStepIndexByPlanKey,
    (_state: RootState, lookup?: PlanLookup) => lookup
  ],
  (loadingStepIndexByPlanKey, lookup) => {
    if (!lookup) return 0;

    const key = buildCreditPlanStoreKey(lookup);
    if (!key) return 0;

    return loadingStepIndexByPlanKey[key] ?? 0;
  }
);
